<template>
  <nav class="navbar">
    <div class="navbar-left">
      
      <button class="nav-btn" @click="goTo('editor')">
        <Icon 
          :name="'edit'"
          size="20"
        />
      </button>
    </div>

    <div class="navbar-right">
      <button class="nav-btn" @click="$emit('open-preview')">
        <Icon 
          :name="'play'"
          size="20"
        />
      </button>

      <button class="nav-btn" @click="openProfileModal()">
        <Icon 
          :name="'profile'"
          size="20"
        />

        <ProfileModal 
          v-model="showProfileModal"
          @edit-profile="onEditProfile"
        />
      </button>
    </div>
  </nav>
</template>

<script>
import ProfileModal from '@/components/pages/admin/profile/ProfileModal.vue'

export default {
  name: 'Navbar',
  components: {
    ProfileModal
  },
  emits: ['open-preview', 'open-profile'],
  data () {
    return {
      showProfileModal: false,
    }
  },
  methods: {
    goTo (path) {
      this.$router.push('/' + path)
    },
    onEditProfile () {
      
    },
    openProfileModal () {
      this.showProfileModal = !this.showProfileModal
    }
  }
}
</script>

<style scoped>
.navbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: var(--grey-2);
  padding: 0.5rem 1rem;
  gap: 0.7rem;
  width: 100%;
  z-index: 1;
  height: 3rem;
}

.navbar-left,
.navbar-right {
  display: flex;
  gap: 0.7rem;
  height: 2rem;
}

.nav-btn {
  background: var(--color-bg);
  border: none;
  padding: 6px;
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: gray; /* исходный цвет иконок */
  transition: color 0.3s ease, background 0.3s ease;
}

.nav-btn svg path,
.nav-btn svg circle,
.nav-btn svg rect,
.nav-btn svg polygon {
  fill: currentColor;
  stroke: currentColor;
}

.nav-btn .arrow {
  margin-left: 4px;
}

.nav-btn:hover {
  background: #3a3a3a;
  color: white; /* hover цвет иконки */
}
</style>
